import { IEntity } from '@/models/common/entity';
import { isNull } from '@/shared/utils/utils';

export class MailWizz implements IEntity {
    id: number = 0;
    name: string;
    privateKey: string;
    publicKey: string;
    url: string;

    get isNew() { return this.id === 0; }

    static clone(record: MailWizz, props?: any) {
        if (isNull(record)) {
            return null;
        }

        return Object.assign(new MailWizz(), record, props);
    }

    static parseJson(json: any): MailWizz {
        if (json === null || json === undefined) { 
            return null;
        }

        return Object.assign(new MailWizz(), json);
    }
}
